<template>
  <div
    class="modal"
    v-if="openOtherSpeciesPopup === true"
    :class="{ visible: openOtherSpeciesPopup }"
  >
    <div class="frame visible">
      <div class="header">
        <h4>Other wildlife</h4>
        <div class="close" @click="closeModal">
          <i class="fa far fa-times"></i>
        </div>
      </div>
      <div class="content-container">
        <div class="content">
          <div class="items">
            <div class="item" v-for="specie of otherSpecies" :key="specie.speciesid" @click="loadSpecie(specie)">
              <img :src="specie.picture" :alt="specie.commonname"  />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'OtherSpeciesPopup',
    data() {
      return {
        species: [],
      };
    },
    computed: {
      ...mapGetters(['openOtherSpeciesPopup', 'electorateName', 'otherSpecies']),
    },
    methods: {
      closeModal() {
        this.$store.commit("updateOpenOtherSpeciesPopup", false);

        // Log close popup
        this.$store.dispatch("logSimpleEvent", {
          eventName: "Click (x) to close",
          eventProperties: { "Close": 'Other species' },
        });
      },
      async loadSpecie(specie) {
        try {
          const speciesData = await this.$store.dispatch("getHeroSpecies", {
            electorate: this.electorateName,
            speciesid: specie.speciesid,
          });
          speciesData.speciesCount = 0;
          this.$store.commit("updateSpeciesData", speciesData);

          this.closeModal();
        } catch (err) {
          console.error(err);
        }
      },
    },
  }
</script>

<style scoped>
.modal {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: rgba(0,0,0, 0.9);
  transition: 0.5s;
}

.modal.visible {
  display: flex;
}

.modal .frame {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  height: auto;
  width: 90%;
  max-width: 1000px;
  
  /* Used for dev as we are outside a iframe */
  /* margin-top: 5%; */

  /* Used for prod as we are within an iframe */
  margin-top: 1200px;
  
  padding: calc(4 * var(--space));
  background-color: var(--white);
}

.modal .frame .close {
  cursor: pointer;
}

.modal .frame.visible {
  display: flex;
}

.modal .frame h2,
.modal .frame p,
.modal .frame i {
  color: var(--black);
  margin: 0;
  text-align: center;
}

.header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

h4 {
  margin: 0;
  text-transform: uppercase;
}

.modal .frame .content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
}

.modal .frame h4 {
  font-family: "WWF",sans-serif;
  font-size: 48px;
  line-height: normal;
  text-transform: uppercase;
}

.modal .frame .items {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 14px;
}

.modal .frame .items .item {
  width: 18%;
  height: 250px;
  cursor: pointer;
}
.modal .frame .items .item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal .frame .content-container {
  overflow-y: auto;
  height: 528px;
}

@media screen and (max-width: 1150px) {
  /* .modal {
    left: 30%;
    width: 50%;
  } */
}

@media screen and (max-width: 950px) {
  /* .modal {
    left: 25%;
    width: 55%;
  } */
}

@media screen and (max-width: 860px) {
  /* .modal {
    top: 10%;
    left: 20%;
    width: 60%;
  } */
}

@media screen and (max-width: 800px) {
  .modal .frame {
    width: 100%;
    height: 100%;
  }
  .modal .frame h4 {
    font-size: 24px;
  }
  .modal .frame .items {
    gap: 3px;
  }
  .modal .frame .items .item {
    width: 49%;
    height: 140px;
    cursor: pointer;
  }
  .modal .frame .content-container {
    overflow-y: auto;
    height: 100vh;
  }
  /* .modal {
    left: 15%;
    width: 75%;
  }

  .modal .frame {
    height: 280px;
  } */
}

@media screen and (max-width: 650px) {
  /* .modal {
    left: 8%;
    width: 85%;
  } */
}

@media screen and (max-width: 550px) {
  /* .modal .frame {
    height: 60%;
  } */
}
/* END */
</style>



// WEBPACK FOOTER //
// OtherSpeciesPopup.vue?2ab2d847